// extracted by mini-css-extract-plugin
export var container = "WidgetCardsContainer-module--container--54b7c";